import React from 'react'
import { Link } from 'react-router-dom';

export const MobileMenuItem = ({url, title, activeLinks = []}) => {

  return (
    <div className="menu-item here show me-lg-1">
        <Link to={url} className="menu-title">
            <span className={`menu-link py-3 ${activeLinks.some(link => window.location.pathname.includes(link)) ? 'active' : ''}`}>{title}</span>
        </Link>
    </div>
  )
}
